import { render, staticRenderFns } from "./PnetExtraVehicleInformation.vue?vue&type=template&id=13c65402&scoped=true"
import script from "./PnetExtraVehicleInformation.vue?vue&type=script&lang=js"
export * from "./PnetExtraVehicleInformation.vue?vue&type=script&lang=js"
import style0 from "./PnetExtraVehicleInformation.vue?vue&type=style&index=0&id=13c65402&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13c65402",
  null
  
)

export default component.exports